module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-global-method-157.vue");


//////////////////
// WEBPACK FOOTER
// ./en/development/vue-global-method.md
// module id = 575
// module chunks = 219